import React, { useState } from 'react';
import MatchResult from './MatchResult';

const BatchMatchResults = ({ batchResults, onUpdateMatchStatus }) => {
  const [expandedStudents, setExpandedStudents] = useState({});

  if (!batchResults || !batchResults.results) {
    return null;
  }

  const { batch_id, results, summary, cost_data } = batchResults;

  const toggleStudent = (studentUuid) => {
    setExpandedStudents(prev => ({
      ...prev,
      [studentUuid]: !prev[studentUuid]
    }));
  };

  const handleStatusChange = async (matchId, newStatus) => {
    if (onUpdateMatchStatus) {
      await onUpdateMatchStatus(matchId, newStatus);
    }
  };

  return (
    <div className="batch-match-results">
      <div className="batch-header">
        <h2>Batch Match Results</h2>
        <div className="batch-summary">
          <span className="summary-item">
            <strong>{summary.total_students}</strong> students matched
          </span>
          <span className="summary-item">
            <strong>{summary.total_matches_generated}</strong> total matches
          </span>
          {summary.tutors_at_capacity?.length > 0 && (
            <span className="summary-item warning">
              <strong>{summary.tutors_at_capacity.length}</strong> tutors at capacity
            </span>
          )}
        </div>
        {cost_data && (
          <div className="batch-cost">
            Est. cost: ${cost_data.cost?.toFixed(4) || cost_data.total_cost?.toFixed(4) || '0.00'}
          </div>
        )}
      </div>

      <div className="batch-id-info">
        <small>Batch ID: {batch_id}</small>
      </div>

      {summary.tutors_at_capacity?.length > 0 && (
        <div className="capacity-warning-banner">
          <strong>Tutors at capacity:</strong> {summary.tutors_at_capacity.join(', ')}
        </div>
      )}

      <div className="student-results-list">
        {results.map((studentResult) => (
          <div key={studentResult.student_uuid} className="student-result-card">
            <div
              className="student-result-header"
              onClick={() => toggleStudent(studentResult.student_uuid)}
            >
              <div className="student-info">
                <h3>
                  {studentResult.student?.grade_year_level || 'Student'}
                  {studentResult.student?.target_subjects && (
                    <span className="subject-tag">
                      {studentResult.student.target_subjects}
                    </span>
                  )}
                </h3>
                <span className="match-count">
                  {studentResult.matches?.length || 0} matches
                </span>
              </div>
              <span className={`expand-icon ${expandedStudents[studentResult.student_uuid] ? 'expanded' : ''}`}>
                {expandedStudents[studentResult.student_uuid] ? '−' : '+'}
              </span>
            </div>

            {studentResult.error && (
              <div className="student-error">
                Error: {studentResult.error}
              </div>
            )}

            {expandedStudents[studentResult.student_uuid] && (
              <div className="student-matches">
                {studentResult.matches?.length > 0 ? (
                  studentResult.matches.map((match, index) => (
                    <div key={match.tutor_id} className="match-wrapper">
                      <MatchResult match={match} rank={index + 1} />
                      <div className="match-actions">
                        <button
                          className="btn-confirm"
                          onClick={() => handleStatusChange(match.id, 'ACTIVE')}
                        >
                          Confirm Match
                        </button>
                        <button
                          className="btn-reject"
                          onClick={() => handleStatusChange(match.id, 'CANCELLED')}
                        >
                          Reject
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="no-matches">No matches found for this student</div>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BatchMatchResults;
